import { Grid, Typography } from '@mui/material'
import LatestVideos from '../components/LatestVideos/LatestVideos'
import MainFeaturedPost from '../components/MainFeaturedPost/MainFeaturedPost'
import SkillSetList from '../organisms/SkillSetList'

const post = {
    description: [
        "I'm a web developer with +25yoe in the IT market. Know more about my professional career here.",
        "Passionate about exploring modern frontend architectures and crafting robust backend solutions.",
        "Dedicated to writing clean, scalable code and delivering seamless user experiences."
    ],
    image: "/static/images/techbg.jpg",
    imageText: "Technology",
    linkText: [
        "Find more about me...",
        "See my work...",
        "Get in touch..."
    ],
    title: [
        "Hi! My name is Alex.",
        "Hi, I'm Alex. I'm a Fullstack Developer.",
        "Hi, I'm Alex. Welcome to my cave.",
    ],
    url: "/about-me"
}

function Home() {
    return (
        <>
            <Grid container>
                <Grid item lg={12}>
                    <MainFeaturedPost post={post} />
                </Grid>
                <Grid item>
                    <Grid container spacing={2} pl={2}>
                        <Grid item>
                            <Typography variant="h5">My Skillset <hr /></Typography>
                            <SkillSetList />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="h5">My latest videos <hr /></Typography>
                            <LatestVideos />
                        </Grid>
                        {/* <Grid item xs={12}>
                        <Typography variant="h5">Stay in touch<hr /></Typography>
                        <ContactForm />
                    </Grid> */}
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default Home